import { render } from "./Empresa_Saldo.vue?vue&type=template&id=3e1dc53c"
import script from "./Empresa_Saldo.vue?vue&type=script&lang=js"
export * from "./Empresa_Saldo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__